var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/star_circle.a1113a7c.png","uri@2x": __webpack_public_path__ + "static/media/star_circle.6447cbe3.png","uri@3x": __webpack_public_path__ + "static/media/star_circle.a05c4f66.png",
    width: 20,
    height: 20
});